var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessageSent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "176px",
    height: "176px",
    viewBox: "0 0 176 176",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "7F3DF325-17D0-4C6B-A23B-1AF9EFE1D55B") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Contact-Us",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Contact-Us-Success",
    transform: "translate(-944.000000, -406.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "illustrations/message-sent",
    transform: "translate(944.000000, 406.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#DAF5EA",
    cx: 88,
    cy: 88,
    r: 88
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117,63 C121.418278,63 125,66.581722 125,71 L125,89.31 L109.303559,105.006164 L98.4905658,94.1933514 C96.9284686,92.6312542 94.3958087,92.6312542 92.8337115,94.1933514 L86.2720779,100.754985 C84.7099808,102.317082 84.7099808,104.849742 86.2720779,106.411839 L90.861,111 L61,111 C56.581722,111 53,107.418278 53,103 L53,71 C53,66.581722 56.581722,63 61,63 L117,63 Z",
    id: "Path",
    fill: "#5ADBA9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117,63 C118.968415,63 120.770785,63.710917 122.164363,64.8900011 L89,87 L55.8350246,64.8905194 C57.2286864,63.7111254 59.0312971,63 61,63 L117,63 Z",
    id: "Path",
    fill: "#19C07F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.281127,89.5224941 L137.006558,92.2479251 C137.787607,93.0289737 137.787607,94.2953036 137.006558,95.0763522 L110.718103,121.364808 C109.937055,122.145856 108.670725,122.145856 107.889676,121.364808 L91.5224941,104.997626 C90.7414455,104.216577 90.7414455,102.950247 91.5224941,102.169198 L94.2479251,99.4437675 C95.0289737,98.6627189 96.2953036,98.6627189 97.0763522,99.4437675 L107.88937,110.25712 C108.629283,110.997088 109.804766,111.036054 110.590565,110.374016 L110.717782,110.257154 L131.4527,89.5224941 C132.233749,88.7414455 133.500079,88.7414455 134.281127,89.5224941 Z",
    id: "Path",
    fill: "#19C07F",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageSent);
export default __webpack_public_path__ + "static/media/messageSent.a8132ad127cf68b0dec380621554a7eb.svg";
export { ForwardRef as ReactComponent };